import Vue from "vue";
import App from "./App.vue";
import router from "./app-routes";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
	faFacebookF,
	faTwitter,
	faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import JQuery from "jquery";

window.$ = JQuery;

library.add(faFacebookF, faTwitter, faLinkedinIn, faEnvelope);

Vue.component("font-awesome-icon", FontAwesomeIcon);

new Vue({
	el: "#app",
	router,
	render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js